import {IImposter, IImposterMap, IImposterMapPrimitive, IImposterMapValue, IImposterOptions} from '~/interfaces/imposterInterfaces'
import {ModelType} from '~/enums/modelType'
import {Logger} from "~/services/logger";

type ComparisonKeys = 'id'| 'genericType'| 'modelType'| 'isCollection'

/**
 * The idea of all this is to be able to have one type of object act like another.
 * The use case right now is a lookup form field for an object model behaving like an actual object model
 * for the purposes of deciding if the lookup field can be mapped to an object in a ProcessFlow set data step
 */
export default class Imposter implements IImposter {
  constructor(private imposterMap: IImposterMap, private options: Partial<IImposterOptions> = {}) {
  }

  get id(): string {
    return this.getValue('id')
  }

  get genericType() {
    return this.getValue('genericType')
  }

  get modelType(): ModelType {
    return this.getValue('modelType')
  }

  get isCollection(): boolean {
    return this.getValue('isCollection')
  }

  get isSingle(): boolean {
    return !this.isCollection
  }

  /**
   * Compare everything or limit comparison to +props+
   *
   * @param otherImposter {IImposter}
   * @param props
   */
  isEqual(otherImposter: IImposter, {props}: { props?: Array<ComparisonKeys> } = {}): boolean {
    if (!props?.length) {
      props = ['id', 'genericType', 'modelType', 'isCollection']
    }
    if (Logger.state['Imposter#isEqual']) {
      console.table([this.serialize(), otherImposter.serialize()])
    }

    return props.every(p => this[p] === otherImposter[p])
  }

  serialize(): Partial<IImposter> {
    return {
      id: this.id,
      modelType: this.modelType,
      genericType: this.genericType,
      isCollection: this.isCollection,
    }
  }

  private getValue<T extends keyof IImposterMap>(key: T): IImposterMapPrimitive[T] {
    const value = this.imposterMap[key] as IImposterMapValue<T>
    if (value instanceof Function) {
      return value?.(this.options)
    } else {
      return value
    }
  }
}